import React, { useState, useEffect } from "react";
import BrightcoverPlayer from "@brightcove/react-player-loader";
import styled from "styled-components";
import VideoThumnnails from "./videoThumbnails";
import { useInterval } from "../../hooks"

export default ({
  initialVideoId, 
  playerId, 
  onDemandVideoId, 
  onPlaylistReady, 
  onDemandPlaylistId }) => {

  const [player, setPlayer] = useState();
  const [ondemandVideos, setOndemandVideos] = useState([]);
  const liveEventVideoId = "6200287585001";

  const getOnDemandPlaylist = () => {
    player && player.catalog.getPlaylist(onDemandPlaylistId, (error, videos) => {
      console.log('getOnDemandPlaylist videos', videos)
      if (error) {
        throw new Error(error);
      }
      setOndemandVideos(videos);
    });
  }

  const playerVideo = (videoId) => {
    player.catalog.getVideo(videoId, (error, video) => {
      player.catalog.load(video)
      player.play()
      window.scrollTo(0,0)
    });
  }

  // useInterval( getOnDemandPlaylist, (1000*10) )
  
  // useEffect( () => {
  //   const interval =  setInterval( () => getOnDemandPlaylist, (1000*10) )
  //   return () => clearInterval(interval)
  // }, [player])

  // useEffect( () => {
  //   if( onDemandVideoId && onDemandVideoId.length > 0 ){
  //     console.log('onDemandVideoId',onDemandVideoId)
  //     playerVideo(onDemandVideoId)
  //   }
  // }, [onDemandVideoId])
  
  // useEffect( () => {
  //   if(onPlaylistReady){
  //     onPlaylistReady(ondemandVideos.map( video => video.id ))
  //     setOndemandVideos(ondemandVideos)
  //   }
  // }, [ondemandVideos])
  
  const handleOnSuccess = (success) => {
    let player = (window.player = success.ref);
    setPlayer(success.ref);

    // player.muted(true)
    // player.play()
    // .then( () => { player.muted(false)} )
    // .catch( error => {console.log(error)})

    // ADD CONTROLBAR BUTTONS
    let controlBar = document.getElementsByClassName("vjs-control-bar")[0];
    let branding = document.createElement("button");
    branding.setAttribute("class", "branding");
    branding.textContent = "live";
    controlBar.appendChild(branding);

    // SET ENDSCREEN MESSAGE
    player.customEndscreen && player.customEndscreen({
      content: "<strong>Content</strong> for <em>custom</em> end screen.",
    });

    // GET PLAYLIST VIDEOS
    getOnDemandPlaylist()

    // ON LIVE EVENT END
    // player.one("ended", function() {
    //   player.catalog.getVideo(liveEventVideoId, (error, video) => {
    //     player.catalog.load(video)
    //     player.play()
    //   });
    // })

    player.on("error", (error) => {
      var errNo = player.error().code;
      var duration = player.duration();
      console.log(errNo === "VIDEO_CLOUD_ERR_NOT_PLAYABLE", duration);
      player.errorDisplay.hide();
      alert("event has not started yet");
      // showModal
      // or playAnotherVideo
    });

    // player.one("bc-catalog-error", () =>  {
    //   console.log(player.catalog.error.data[0].error_code)
    // })
  };

  const handleOnFailure = (err) => {
    // {code: "VIDEO_CLOUD_ERR_RESOURCE_NOT_FOUND", message: ""}
    // code: 4 for scheduled error
    // play pre..
    console.log("err", err);
  };

  return (
    <LiveEventWrapper>
      <PlayerWrapper>
        <BrightcoverPlayer
          attrs={{ className: "player" }}
          playerId={playerId}
          videoId={initialVideoId} // liveEventVideoId
          // playlistId={onDemandPlaylistId}
          accountId="6188831335001"
          onSuccess={handleOnSuccess}
          onFailure={handleOnFailure}
          onEmbedCreated={(e) => {
            console.log("embed created", onDemandPlaylistId);
          }}
        />
      </PlayerWrapper>
    </LiveEventWrapper>
  );
};

const PlayerWrapper = styled.div`
  position: relative;
  display: block;
  max-width: 960px;

  video-js {
    // width: 100%;
    padding-top: 56%;
    // position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
  }

  .vjs-control-bar .branding {
    // margin-top: 3px;
    // margin-right: 4px;
    // width: 85px;
    // height: 22px;
    background: #e4e4e4;
    text-transform: uppercase;
    // font-size: 8px;
  }

  .vjs-dock-text {
    background: linear-gradient(180deg, #00000073, transparent);

    .vjs-dock-description,
    .vjs-dock-title {
      color: white;
    }
  }
`;

const LiveEventWrapper = styled.div`
  .code {
    width: 100%;
    overflow: hidden;
    overflow: scroll;
    font: message-box;
    font-size: 1.2em;
    height: 500px;
  }
`;
